/* eslint-disable camelcase */
import React, { useContext, useEffect } from 'react';
import { Badge, Icon, Text } from 'components';
import {
  AuthContext,
  ContextualChatContext,
  ChannelType,
  ChatButtonSettingsType,
} from 'contexts';
import { useLocation } from 'react-router-dom';
import { useStartChat } from 'hooks';
import styled from 'styled-components';
import { BadgeParent } from './BadgeParent';

const ContextualChatButton = () => {
  const { pathname } = useLocation();

  const {
    setChatModalVisible,
    buttonSettings,
    setButtonSettings,
    chatButtonDisplayText,
    unreadCount,
  } = useContext(ContextualChatContext);

  const { auth } = useContext(AuthContext);

  const { startChat } = useStartChat();

  useEffect(() => {
    // Matches /my_business/showing/:showingId
    const showingPageRegEx = new RegExp(/\/my_business\/showing\/([^/]+)$/);
    // Matches /listing/:listingId/view
    const listingPageRegEx = new RegExp(/\/listing\/([^/]+)\/view/);

    const matchedPathname =
      pathname.match(showingPageRegEx) ?? pathname.match(listingPageRegEx);

    if (matchedPathname) {
      setButtonSettings({ ...buttonSettings, enableCreateListingChat: true });
    } else {
      // We want to manually clean the current settings to avoid stale data from a previous listing navigation
      setButtonSettings({
        enableCreateListingChat: false,
        repIds: [''],
        listingId: '',
        userIdToCreateChannelId: '',
      });
    }
  }, [pathname, setButtonSettings]);

  return (
    <MessagesButton
      onClick={() => {
        const {
          repIds,
          enableCreateListingChat,
          listingId,
          userIdToCreateChannelId,
        } = buttonSettings;

        // Allows to create a listing centric conversation right from the chat button
        if (
          repIds.length >= 1 &&
          repIds[0].length &&
          enableCreateListingChat &&
          listingId
        ) {
          startChat({
            userId: auth.streamChatId,
            selectedUsers: repIds.map(repId => ({ id: repId })),
            listingId,
            channelType: ChannelType.listing,
            ...(userIdToCreateChannelId && { userIdToCreateChannelId }),
          });
        }
        // Regardless of creating a listing-centric chat, we open the chat modal as usual
        setChatModalVisible(true);
      }}
    >
      <BadgeParent countNode={unreadCount}>
        <Icon type="antdMessageFilled" color="white" width={20} />
      </BadgeParent>
      <Text color="white" style={{ margin: '0px' }}>
        {chatButtonDisplayText}
      </Text>
    </MessagesButton>
  );
};

const MessagesButton = styled.button`
  bottom: 40px;
  right: 40px;
  position: fixed;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #2b2b2b;
  color: white;
  padding: 12px 16px;
  z-index: 10; // Needed so that it is in front of the Brokerage Listings table
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
`;

export default ContextualChatButton;
